import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerArchiveInfo } from "../../utils/apiDescription/sso/archive";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { archivedOrganizerRequestParameter, archivedOrganizerResponseBody, organizerCommonRequestBody, resendAccessLinkRequestBody, signerDetailsRequestParameter, signerDetailsResponseBody } from "../../utils/sso/apiObjects";
import { archivedOrganizerJsonRequestCurl, deleteOrganizerJsonRequestCurl, moveToDeliveredJsonRequestCurl, resendAccessLinkJsonRequestCurl, signerDetailsJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";
import { archivedOrganizerJsonResponse, signerDetailsJsonResponse } from "../../utils/sso/sampleJsonResponse";

const archivedOrganizers: API = {
    name: "Archived Organizers",
    url: `${API_BASE_URL}/${SSO.ARCHIVED.ARCHIVED_ORGANIZERS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerArchiveInfo.archivedOrganizers,
    requestBody: archivedOrganizerRequestParameter,
    responseBody: archivedOrganizerResponseBody,
    jsonRequest: archivedOrganizerJsonRequestCurl,
    jsonResponse: archivedOrganizerJsonResponse,
}
const deleteOrganizer: API = {
    name: "Delete Organizer API",
    url: `${API_BASE_URL}/${SSO.ARCHIVED.DELETE_ORGANIZERS_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: organizerArchiveInfo.deleteOrganizer,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteOrganizerJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}
const moveToDelivered: API = {
    name: "Move To Delivered",
    url: `${API_BASE_URL}/${SSO.ARCHIVED.MOVE_TO_DELIVERED}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: organizerArchiveInfo.moveToDelivered,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: moveToDeliveredJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}
const resendAccessLink: API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SSO.ARCHIVED.RESEND_ACCESS_LINK}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: organizerArchiveInfo.resendAccessLink,
    requestBody: resendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: resendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}
const signerDetails: API = {
    name: "Signer Details",
    url: `${API_BASE_URL}/${SSO.ARCHIVED.SIGNER_DETAILS}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerArchiveInfo.signerDetails,
    requestBody: signerDetailsRequestParameter,
    responseBody: signerDetailsResponseBody,
    jsonRequest: signerDetailsJsonRequestCurl,
    jsonResponse: signerDetailsJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Archived Organizers':
            return archivedOrganizers;
        case 'Delete Organizer API':
            return deleteOrganizer;
        case 'Move To Delivered':
            return moveToDelivered;
        case 'Resend Access Link':
            return resendAccessLink;
        case 'Signer Details':
            return signerDetails;
    }
}